import * as _ from 'lodash-es';

import cssFilter from './cssFilter';
// do some code change
// whiteList
function getWhiteList() {
	return {
		a: ['target', 'href', 'title'],
		abbr: ['title'],
		address: [],
		area: ['shape', 'coords', 'href', 'alt'],
		article: [],
		aside: [],
		audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
		b: [],
		bdi: ['dir'],
		bdo: ['dir'],
		big: [],
		blockquote: ['cite'],
		br: [],
		caption: [],
		center: [],
		cite: [],
		code: [],
		col: ['align', 'valign', 'span', 'width'],
		colgroup: ['align', 'valign', 'span', 'width'],
		dd: [],
		del: ['datetime'],
		details: ['open'],
		div: [],
		dl: [],
		dt: [],
		em: [],
		font: ['color', 'size', 'face'],
		footer: [],
		h1: [],
		h2: [],
		h3: [],
		h4: [],
		h5: [],
		h6: [],
		header: [],
		hr: [],
		i: [],
		img: ['src', 'alt', 'title', 'width', 'height'],
		ins: ['datetime'],
		li: [],
		mark: [],
		nav: [],
		ol: [],
		p: [],
		pre: [],
		s: [],
		section: [],
		small: [],
		span: [],
		sub: [],
		sup: [],
		strong: [],
		table: ['width', 'border', 'align', 'valign'],
		tbody: ['align', 'valign'],
		td: ['width', 'colspan', 'align', 'valign'],
		tfoot: ['align', 'valign'],
		th: ['width', 'colspan', 'align', 'valign'],
		thead: ['align', 'valign'],
		tr: ['rowspan', 'align', 'valign'],
		tt: [],
		u: [],
		ul: [],
		video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width'],
	};
}

// UTIL
// 正则表达式
const REGEXP_LT = /</g;
const REGEXP_GT = />/g;
const REGEXP_QUOTE = /"/g;
const REGEXP_QUOTE_2 = /&quot;/g;
const REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
const REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
const REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
const REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
const REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi;
const REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
const REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
const REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
const REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
const STRIP_COMMENT_TAG_REGEXP = /<!--[\s\S]*?-->/g;
/**
 * HTML转义
 *
 * @param {String} html
 */
function escapeHtml(html) {
	return html.replace(REGEXP_LT, '&lt;').replace(REGEXP_GT, '&gt;');
}
/**
 * 对双引号进行转义
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
	return str.replace(REGEXP_QUOTE, '&quot;');
}
function unescapeQuote(str) {
	return str.replace(REGEXP_QUOTE_2, '"');
}
/**
 * 对html实体编码进行转义
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
	return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
		return code[0] === 'x' || code[0] === 'X'
			? String.fromCharCode(parseInt(code.substr(1), 16))
			: String.fromCharCode(parseInt(code, 10));
	});
}
/**
 * 对html5新增的危险实体编码进行转义
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
	return str.replace(REGEXP_ATTR_VALUE_COLON, ':').replace(REGEXP_ATTR_VALUE_NEWLINE, ' ');
}
/**
 * 清除不可见字符
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
	var str2 = '';
	for (var i = 0, len = str.length; i < len; i++) {
		str2 += str.charCodeAt(i) < 32 ? ' ' : str.charAt(i);
	}
	return _.trim(str2);
}
/**
 * 将标签的属性值转换成一般字符，便于分析
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
	str = unescapeQuote(str); // 双引号
	str = escapeHtmlEntities(str); // 转换HTML实体编码
	str = escapeDangerHtml5Entities(str); // 转换危险的HTML5新增实体编码
	str = clearNonPrintableCharacter(str); // 清除不可见字符
	return str;
}
/**
 * 转义用于输出的标签属性值
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
	str = escapeQuote(str);
	str = escapeHtml(str);
	return str;
}

/**
 * 去除备注标签
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
	return html.replace(STRIP_COMMENT_TAG_REGEXP, '');
}
/**
 * 去除不可见字符
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
	var chars = html.split('');
	chars = chars.filter(function (char) {
		var c = char.charCodeAt(0);
		if (c === 127) return false;
		if (c <= 31) {
			if (c === 10 || c === 13) return true;
			return false;
		}
		return true;
	});
	return chars.join('');
}
/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
	return obj === undefined || obj === null;
}

// --here.
const _wl = getWhiteList();
// parser...
function getTagName(html) {
	var i = html.indexOf(' ');
	let tagName;
	if (i === -1) {
		tagName = html.slice(1, -1);
	} else {
		tagName = html.slice(1, i + 1);
	}
	tagName = _.trim(tagName).toLowerCase();
	if (tagName.slice(0, 1) === '/') tagName = tagName.slice(1);
	if (tagName.slice(-1) === '/') tagName = tagName.slice(0, -1);
	return tagName;
}

function isClosing(html) {
	return html.slice(0, 2) === '</';
}

const REGEXP_ATTR_NAME = /[^a-zA-Z0-9_:\.\-]/gim;

function htmlParser(htmlStr) {
	htmlStr = _.trim(htmlStr);
	var slicePos = 0;
	var htmlRes = '';
	var i = 0;
	var htmlLen = htmlStr.length;
	var tagStart = false;
	var quoteStart = false;
	var currentHTML = '';

	// 逐字符分析，我容易吗我
	for (i; i < htmlLen; i++) {
		var c = htmlStr[i];
		if (tagStart === false) {
			if (c === '<') {
				tagStart = i;
				continue;
			}
		} else {
			if (quoteStart === false) {
				if (c === '<') {
					htmlRes += escapeHtml(htmlStr.slice(slicePos, i));
					tagStart = i;
					slicePos = i;
					continue;
				} else if (c === '>') {
					// 标签闭合
					htmlRes += escapeHtml(htmlStr.slice(slicePos, tagStart));
					//  ---
					currentHTML = htmlStr.slice(tagStart, i + 1);
					const currentTagName = getTagName(currentHTML);
					htmlRes += tagParser(currentTagName, currentHTML);
					slicePos = i + 1;
					tagStart = false;
					continue;
				}
				// HTML标签内的引号仅当前一个字符是等于号时才有效
				if ((c === '"' || c === "'") && htmlStr.charAt(i - 1) === '=') {
					quoteStart = c;
					continue;
				}
			} else {
				// 判断是否需要清空引号的状态
				if (c === quoteStart) {
					quoteStart = false;
					continue;
				}
			}
		}
	}

	if (slicePos < htmlStr.length) {
		htmlRes += escapeHtml(htmlStr.substr(slicePos));
	}
	return htmlRes;
}

//process
/**
 * 安全的标签属性值
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value) {
	// 转换为友好的属性值，再做判断
	// console.log('old Value::', value);
	value = friendlyAttrValue(value);
	// console.log(value);
	if (name === 'href' || name === 'src') {
		// 过滤 href 和 src 属性
		// 仅允许 http:// | https:// | mailto: | / | # 开头的地址
		value = _.trim(value);
		if (value === '#') return '#';
		if (
			!(
				value.substr(0, 7) === 'http://' ||
				value.substr(0, 8) === 'https://' ||
				value.substr(0, 7) === 'mailto:' ||
				value[0] === '#' ||
				value[0] === '/'
			)
		) {
			return '';
		}
	} else if (name === 'background') {
		// 过滤 background 属性 （这个xss漏洞较老了，可能已经不适用）
		// javascript:
		REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
		if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
			return '';
		}
	} else if (name === 'style') {
		// expression()
		REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
		if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
			return '';
		}
		// url()
		REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
		if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
			REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
			if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
				return '';
			}
		}
		value = cssFilter(value);
	}

	// 输出时需要转义<>"
	value = escapeAttrValue(value);
	return value;
}
function htmlInfo(html) {
	var i = html.indexOf(' ');
	if (i === -1) {
		return {
			attr: '',
			closing: html[html.length - 2] === '/',
		};
	}
	html = _.trim(html.slice(i + 1, -1));
	var isClosing = html[html.length - 1] === '/';
	if (isClosing) html = _.trim(html.slice(0, -1));
	return {
		attr: html,
		closing: isClosing,
	};
}

function attrParser(html, onAttr) {
	html = _.trim(html);
	var lastPos = 0; // 当前位置
	var retAttrs = []; // 待返回的属性列表
	var tmpName = false; // 临时属性名称
	var len = html.length; // HTML代码长度

	function addAttr(name, value) {
		name = _.trim(name);
		name = name.replace(REGEXP_ATTR_NAME, '').toLowerCase();
		if (name.length < 1) return;
		var ret = onAttr(name, value || '');
		if (ret) retAttrs.push(ret);
	}

	// 逐个分析字符
	for (var i = 0; i < len; i++) {
		var c = html.charAt(i);
		var v, j;
		if (tmpName === false && c === '=') {
			tmpName = html.slice(lastPos, i);
			lastPos = i + 1;
			continue;
		}
		if (tmpName !== false) {
			// HTML标签内的引号仅当前一个字符是等于号时才有效
			if (i === lastPos && (c === '"' || c === "'") && html.charAt(i - 1) === '=') {
				j = html.indexOf(c, i + 1);
				if (j === -1) {
					break;
				} else {
					v = _.trim(html.slice(lastPos + 1, j));
					addAttr(tmpName, v);
					tmpName = false;
					i = j;
					lastPos = i + 1;
					continue;
				}
			}
		}
		if (c === ' ') {
			if (tmpName === false) {
				j = findNextEqual(html, i);
				if (j === -1) {
					v = _.trim(html.slice(lastPos, i));
					addAttr(v);
					tmpName = false;
					lastPos = i + 1;
					continue;
				} else {
					i = j - 1;
					continue;
				}
			} else {
				j = findBeforeEqual(html, i - 1);
				if (j === -1) {
					v = _.trim(html.slice(lastPos, i));
					v = stripQuoteWrap(v);
					addAttr(tmpName, v);
					tmpName = false;
					lastPos = i + 1;
					continue;
				} else {
					continue;
				}
			}
		}
	}

	if (lastPos < html.length) {
		if (tmpName === false) {
			addAttr(html.slice(lastPos));
		} else {
			addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
		}
	}

	return _.trim(retAttrs.join(' '));
}
function findNextEqual(str, i) {
	for (; i < str.length; i++) {
		var c = str[i];
		if (c === ' ') continue;
		if (c === '=') return i;
		return -1;
	}
}

function findBeforeEqual(str, i) {
	for (; i > 0; i--) {
		var c = str[i];
		if (c === ' ') continue;
		if (c === '=') return i;
		return -1;
	}
}

function isQuoteWrapString(text) {
	if ((text[0] === '"' && text[text.length - 1] === '"') || (text[0] === "'" && text[text.length - 1] === "'")) {
		return true;
	} else {
		return false;
	}
}

function stripQuoteWrap(text) {
	if (isQuoteWrapString(text)) {
		return text.substr(1, text.length - 2);
	} else {
		return text;
	}
}

function tagParser(tagName, tagHTML) {
	const _whiteList = _wl;
	// 属于非法的 tagName -- 整体进行转义操作
	if (!_whiteList[tagName]) {
		return escapeHtml(tagHTML);
	}
	// 是闭合标签，不用做多余的处理
	if (isClosing(tagHTML)) {
		return '</' + tagName + '>';
	}
	// 获取各个属性，保留符合要求的属性值
	var whiteListAttr = _whiteList[tagName];
	var tagHtmlInfo = htmlInfo(tagHTML);
	var attrsHtml = attrParser(tagHtmlInfo.attr, (name, value) => {
		// 调用onTagAttr处理
		var isWhiteAttr = _.indexOf(whiteListAttr, name) !== -1;
		// 默认的属性处理方法
		if (isWhiteAttr) {
			// 白名单属性，调用safeAttrValue过滤属性值
			value = safeAttrValue(tagName, name, value);
			if (value) {
				return name + '="' + value + '"';
			} else {
				return name;
			}
		} else {
			return '';
		}
	});

	var html = '<' + tagName;
	html += ' ' + attrsHtml + ' ';
	if (tagHtmlInfo.closing) {
		html += '/';
	}
	html += '>';
	return html;
}

export default function filterProcess(html, extWhiteList = {}) {
	html = html || '';
	html = html.toString();
	if (!html) return '';
	html = stripBlankChar(html);
	html = stripCommentTag(html);
	return htmlParser(html);
}

export const filterParams = (str) => {
	let res = filterProcess(str);
	// 强制不正确的过滤
	REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
	if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(res)) {
		return '';
	}
	// expression()
	REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
	if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(res)) {
		return '';
	}
	// url()
	REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
	if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(res)) {
		REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
		if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(res)) {
			return '';
		}
	}

	return res;
};
